import React from 'react';
import CustomHtmlPrompt from '../../../components/inputs/CustomHtmlPrompt';

class TPIThankyou extends React.Component {
  constructor(props) {
    super(props);
    // eslint-disable-next-line react/no-unused-state
    this.state = { modal: {}, nextButtonClass: 'display-none' };
  }

  render() {
    const {
      surveyPresent,
      thankyouText,
      thankyouHtmlSafe,
      thankYouText1,
      thankYouText2,
      displayWarning,
      warningTextPresent,
      cautionImg,
      optinThankyou,
      cautionText,
    } = this.props;
    return (
      <div id="tpi_thank_you">
        {surveyPresent ? (
          <div id="thank_you">
            <div className="page-inner-content">
              {thankyouText && (
                <div>
                  <h1 className="tpi_text_head d-block mg-15-0">
                    <CustomHtmlPrompt label={thankyouHtmlSafe} />
                  </h1>
                  <p className="tpi_text mg-0">
                    <CustomHtmlPrompt label={thankYouText1} />
                  </p>
                </div>
              )}
              <div className="click_here">
                <CustomHtmlPrompt label={thankYouText2} component="h2" />
              </div>
            </div>
            {displayWarning && warningTextPresent && (
              // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
              <div className="thank_you_caution" tabIndex="0">
                <img
                  alt=""
                  /* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */
                  tabIndex="0"
                  className="caution_img"
                  src={`/assets/${cautionImg}`}
                />
                <p className="caution_text">
                  <CustomHtmlPrompt label={cautionText} />
                  <br />
                </p>
              </div>
            )}
          </div>
        ) : (
          <div
            /* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */
            tabIndex="0"
            dangerouslySetInnerHTML={{ __html: optinThankyou }}
          />
        )}
      </div>
    );
  }
}

export default TPIThankyou;
